import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";

export default function CommonPdfLanguagesSkillsSection( { resumeData, translations } ) {
    const { languageSkills } = extractResumeDataDocumentSection( resumeData );
    const { isAlcyone, documentLanguage } = extractResumeProperties( resumeData );

    const themeColor = isAlcyone ? '#09B4BF' : '#0B86C8';

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 2,
            fontSize: 10,
        },
        sectionTable: {
            flexDirection: 'row',
            fontSize: 10,
        },
        table: {
            width: '100%',
        },
        tableHeader: {
            backgroundColor: themeColor,
            color: themeColor,
            fontWeight: 'bold',
        },
        tableRow: {
            width: '50%',
            textAlign: "center",
            marginTop: 2,
            marginBottom: 2,
        },
        row1: {
            width: '30%',
        },
        row2: {
            width: '25%',
        },
        row3: {
            width: '25%',
        },
        bold: {
            fontWeight: 'bold',
        },
        sectionTitle: {
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: 2,
            textTransform: 'uppercase',
            color: themeColor,
        },
        titleContainer: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        line: {
            flexGrow: 1,
            height: 1,
            backgroundColor: themeColor,
            marginLeft: 5,
        },
        divider: {
            borderBottomColor: themeColor,
            borderBottomWidth: 1,
            marginTop: 2,
            marginBottom: 2,
        },
    } );

    return (
        <View style={ { marginTop: 10 } }>
            <View style={ styles.titleContainer }>
                <Text style={ styles.sectionTitle }>
                    { translations.pdf.languageSkillsTitle }
                </Text>
                <View style={ styles.line }/>
            </View>
            <View style={ styles.table }>
                <View style={ [ styles.section, styles.tableHeader ] }>
                    <Text style={ styles.row1 }>{ ' ' }</Text>
                    <Text style={ [
                        styles.tableRow,
                        { color: "#ffffff", textAlign: "center" }
                    ] }>
                        { translations.pdf.comprehensionHeader }
                    </Text>
                    <Text style={ [
                        styles.tableRow,
                        { color: "#ffffff", textAlign: "right", marginRight: 15 }
                    ] }>
                        { translations.pdf.oralExpressionHeader }
                    </Text>
                    <Text style={ [
                        styles.tableRow,
                        { color: "#ffffff", textAlign: "center" }
                    ] }>
                        { translations.pdf.writingExpressionHeader }
                    </Text>
                </View>
                <View style={ styles.sectionTable }>
                    <Text style={ styles.row1 }></Text>
                    <Text style={ [
                        styles.row2,
                        { fontSize: 6, color: "#000000" }
                    ] }>
                        { translations.pdf.listeningComprehensionHeader }
                    </Text>
                    <Text style={ [
                        styles.row2,
                        { fontSize: 6, color: "#000000" }
                    ] }>
                        { translations.pdf.readingComprehensionHeader }
                    </Text>
                    <Text style={ [
                        styles.row3,
                        { fontSize: 6, color: "#000000" }
                    ] }>
                        { translations.pdf.continuousOralExpressionHeader }
                    </Text>
                    <Text style={ [
                        styles.row3,
                        { fontSize: 6, color: "#000000" }
                    ] }>
                        { translations.pdf.oralInteractionHeader }
                    </Text>
                    <Text style={ [
                        styles.row3,
                        { fontSize: 6, color: "#000000" }
                    ] }>
                        { ' ' }
                    </Text>
                </View>
                <View style={ styles.divider }></View>
                { languageSkills
                    .filter( skill => skill.language )
                    .sort( ( a, b ) => a.order - b.order )
                    .map( ( skill, index ) => (
                        <React.Fragment key={ index }>
                            { index > 0 && ( <View style={ styles.divider }></View> ) }
                            <View style={ styles.section }>
                                <Text style={ [
                                    styles.row1,
                                    styles.bold,
                                    { fontSize: 6 }
                                ] }>
                                    { skill.language?.translations?.[ documentLanguage ] ?? skill.language?.code ?? '' }
                                </Text>
                                <Text style={ [
                                    styles.row2,
                                    { fontSize: 6 }
                                ] }>
                                    { skill.listeningComprehensionLevel?.translations?.[ documentLanguage ] ?? '' }
                                </Text>
                                <Text style={ [
                                    styles.row2,
                                    { fontSize: 6 }
                                ] }>
                                    { skill.readingComprehensionLevel?.translations?.[ documentLanguage ] ?? '' }
                                </Text>
                                <Text style={ [
                                    styles.row3,
                                    { fontSize: 6 }
                                ] }>
                                    { skill.continuousOralExpressionLevel?.translations?.[ documentLanguage ] ?? '' }
                                </Text>
                                <Text style={ [
                                    styles.row3,
                                    { fontSize: 6 }
                                ] }>
                                    { skill.oralInteractionLevel?.translations?.[ documentLanguage ] ?? '' }
                                </Text>
                                <Text style={ [
                                    styles.row3,
                                    { fontSize: 6 }
                                ] }>
                                    { skill.writingExpressionLevel?.translations?.[ documentLanguage ] ?? '' }
                                </Text>
                            </View>
                        </React.Fragment>
                    ) ) }
                <View style={ styles.divider }></View>
            </View>
        </View>
    );
}
